import React from 'react';
import { Link } from 'react-router-dom';
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import { connect } from 'react-redux';
// import logo from "./logo.png";

const Navbar = (props) => {
    const { auth, profile } = props;
    const logostyle = {
        fontFamily:'Sacramento',
        color: 'white',
        fontSize: '50px',
    }
    const links = auth.uid ? <SignedInLinks profile={profile} /> : <SignedOutLinks />;
    return (
        <nav className="nav-wrapper transparent lighten-1 z-depth-0">
            <div className="container">
                <Link to='/' className="brand-logo left" style={logostyle}> Cusaly 
                {/* <img src={logo} alt={"logo"} />  */}
                </Link>
                {links}
            </div>
        </nav>
    )
};

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile
    }
}

export default connect(mapStateToProps)(Navbar);